import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { PCTRegionCodeExtension } from 'app/models/extensions/p-c-t-region-code-extension.model';
import { PCTProvinceGrouping } from 'app/models/p-c-t-province-grouping.model';
import { MRMValidators } from '@mrm/core';

export class PCTRegionCode extends PCTRegionCodeExtension {
  pctRegionCodeDBID: number = 0;
  pctRegionCode1: number = 0;
  englishDescription: string = null;
  frenchDescription: string = null;
  isActive?: boolean = null;
  orderNumber: number = 0;
  showInReportSelection: boolean = false;
  createdDT: Date = new Date();
  createdBy: string = null;
  modifiedDT: Date = new Date();
  modifiedBy: string = null;
  rowVersion: number = 0;
  pctProvinceGroupings: PCTProvinceGrouping[] = [];

  static getForm(disableAll: boolean = false, includeNav: string[] = []): FormGroup {
    const form = new FormGroup({
      pctRegionCodeDBID: new FormControl({ value: 0, disabled: disableAll }),
      pctRegionCode1: new FormControl({ value: 0, disabled: disableAll }, [Validators.required, MRMValidators.number]),
      englishDescription: new FormControl({ value: null, disabled: disableAll }, [Validators.required, Validators.maxLength(255)]),
      frenchDescription: new FormControl({ value: null, disabled: disableAll }, [Validators.required, Validators.maxLength(255)]),
      isActive: new FormControl({ value: null, disabled: disableAll }),
      orderNumber: new FormControl({ value: 0, disabled: disableAll }, [Validators.required, MRMValidators.number]),
      showInReportSelection: new FormControl({ value: false, disabled: disableAll }, [Validators.required]),
      createdDT: new FormControl({ value: new Date(), disabled: disableAll }, [Validators.required]),
      createdBy: new FormControl({ value: null, disabled: disableAll }, [Validators.maxLength(50)]),
      modifiedDT: new FormControl({ value: new Date(), disabled: disableAll }, [Validators.required]),
      modifiedBy: new FormControl({ value: null, disabled: disableAll }, [Validators.maxLength(50)]),
      rowVersion: new FormControl({ value: 0, disabled: disableAll }),
      pctProvinceGroupings: new FormArray([])
    });


    return form;
  }
}